import React from 'react';
import { Form, FormikProvider } from 'formik';
import { Grid, Paper, Divider } from '@mui/material';
import ProfileImageSection from './ProfileImageSection';
import PersonalInfoSection from './PersonalInfoSection';
import EmploymentInfoSection from './EmploymentInfoSection';

// ----------------------------------------------------------------------

export default function ProfileForm({
  formik,
  userId,
  userData,
  profileImagePreview,
  profileImage,
  isEditing,
  canEdit,
  isSubmitting,
  onImageUpload,
  onRemoveImage
}) {
  const { values, errors, touched, getFieldProps, setFieldValue } = formik;

  return (
    <FormikProvider value={formik}>
      <Form>
        <Grid container spacing={3}>
          {/* Profile Image Section */}
          <Grid item xs={12} md={3}>
            <ProfileImageSection
              userId={userId}
              userData={userData}
              profileImagePreview={profileImagePreview}
              profileImage={values.profileImage}
              isEditing={isEditing}
              canEdit={canEdit}
              isSubmitting={isSubmitting}
              onImageUpload={onImageUpload}
              onRemoveImage={onRemoveImage}
            />
          </Grid>

          {/* Profile Details Section */}
          <Grid item xs={12} md={9}>
            <Paper elevation={1} sx={{ p: 3, pb: 2, pt: 2, borderRadius: 2 }}>
              <Grid container spacing={4}>
                {/* Personal Information Column */}
                <Grid item xs={12} md={6}>
                  <PersonalInfoSection
                    isEditing={isEditing}
                    values={values}
                    errors={errors}
                    touched={touched}
                    getFieldProps={getFieldProps}
                    setFieldValue={setFieldValue}
                  />
                </Grid>

                {/* Employment Information Column */}
                <Grid item xs={12} md={6}>
                  <EmploymentInfoSection
                    isEditing={isEditing}
                    values={values}
                    errors={errors}
                    touched={touched}
                    getFieldProps={getFieldProps}
                    setFieldValue={setFieldValue}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
}
